import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView } from '@digital/ui';
import TableBuilUp from './TableBuilUp'
import { CicloOrcamentarioRelatorio, Filtros, postGetAllRelatorioControleRfa } from '@app/api/relatorioCicloorcamentario';


const Buildup = () => {

    const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CicloOrcamentarioRelatorio>();

    const handleFilter = () => {
        const filtros = {
            classificaoRfa: ["cfa9347a-ff40-4842-9b4c-4f19e5eba109"]
        } as Filtros;
        postGetAllRelatorioControleRfa(filtros).then((data) => {
            setCicloOrcamentarioRelatorioTotal(data);
        });
        return true;
    }

    useEffect(() => { handleFilter() }, [])
    return (
        <SimpleView >
            <GridView noform>
                <Widget
                    title="Controle RFA"
                    span={12}
                    actions={[]}>
                    {cicloOrcamentarioRelatorioTotal ?
                        <TableBuilUp
                            cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
                            paginacaoConfig={{ pageSize: 25 }}
                            relatorioControleRfa={true}
                        /> : <> </>}
                </Widget>
            </GridView>
        </SimpleView>
    );
};

export default Buildup;
